<template>
   <Html>
      <ClientOnly>
         <NuxtLoadingIndicator :height="5" color="var(--color-secondary)" />
         <Notification />
      </ClientOnly>

      <Body>
         <PreviewDisclaimer />

         <div id="app-layout" class="bg-light-grey flex h-dvh w-screen">
            <Sidebar />
            <div
               v-if="sidebarStore.$state.open"
               class="starting:opacity-0 fixed inset-0 z-30 bg-black/30 transition-opacity"
               @click="sidebarStore.$state.open = false"
            />
            <main
               class="h-dvh min-w-0 flex-1 overflow-hidden bg-white md:rounded-medium md:border-grey/15 md:my-2 md:mr-2 md:h-[calc(100dvh-1rem)] md:border md:shadow-xs"
            >
               <slot />
            </main>
         </div>
      </Body>
   </Html>
</template>

<script lang="ts" setup>
import { useOrganization } from '~/composables/api/queries/organization'
import { useSidebarStore } from '~/stores/sidebar-store'

const { t } = useI18n()
const route = useRoute()
const pinia = usePinia()
const sidebarStore = useSidebarStore(pinia)
const { $loadAgGrid } = useNuxtApp()

const organization = useOrganization(
   computed(() => ({
      id: route.params.id as string,
      enabled: !!route.params.id,
   }))
)

useSeo(
   () => organization.data.value?.[0]?.translated_name || t('web.seo.layout.dashboard.title'),
   () => t('web.seo.layout.dashboard.description')
)

if (import.meta.client) {
   await $loadAgGrid()
}
</script>
